if ( typeof QuickAddToCart !== 'function' ) {

	class QuickAddToCart extends HTMLElement {
		constructor(){
			super();
			if ( this.querySelector('product-form') ) {
				this.init();
			}
		}
		init(){
			this.querySelector('product-form').addEventListener('add-to-cart', ()=>{
				if ( ! document.body.classList.contains('template-cart') ) {
					document.getElementById('site-cart-sidebar').show();
					if ( KROWN.settings.cart_action == 'overlay') {
						document.querySelectorAll('[data-header-cart-total').forEach(elm=>{
							elm.textContent = document.querySelector('#AjaxCartForm [data-cart-total]').textContent;
						});
						document.querySelectorAll('[data-header-cart-count]').forEach(elm=>{
							elm.textContent = document.querySelector('#AjaxCartForm [data-cart-count]').textContent;
						});
						if ( document.getElementById('cart-recommendations') ) {
							document.getElementById('cart-recommendations').generateRecommendations();
						}
					};
				}
			});
		}
	}

  if ( typeof customElements.get('quick-add-to-cart') == 'undefined' ) {
		customElements.define('quick-add-to-cart', QuickAddToCart);
	}

}

if ( typeof QuickViewProduct !== 'function' ) {

	class QuickViewProduct extends HTMLElement {

		constructor(){
			super();
			if ( this.querySelector('a') ) {
				this.init();
			}
		}

syncOGQuickViewPrice() {
  if (!this.quickViewModal) return;

  const modal = this.quickViewModal;

  if (!modal.ogQuickViewState) {
    modal.ogQuickViewState = {
      /**
       * Guards the one-time-purchase selection so it only ever fires
       * once per modal instance — a real click, the same as a user
       * would make, not a forced/repeated override. Once this has
       * fired (or found nothing to click), it never fires again, so
       * it can't fight a real subscribe selection made afterward.
       */
      hasSelectedOneTime: false,
      selectOneTimeAttempts: 0,
      attributeObserverBound: false
    };
  }

  const state = modal.ogQuickViewState;

  const isVisible = el => {
    if (!el) return false;

    const rect = el.getBoundingClientRect();

    return (
      rect.width > 0 &&
      rect.height > 0 &&
      window.getComputedStyle(el).display !== 'none' &&
      window.getComputedStyle(el).visibility !== 'hidden'
    );
  };

  const getWrapper = () => {
    if (!isVisible(modal)) return null;
    return modal.querySelector('[data-og-price]');
  };

  const getOffer = () => {
    if (!isVisible(modal)) return null;
    return modal.querySelector('og-offer');
  };

  const getOptoutButton = () => {
    const offer = getOffer();
    return offer ? offer.querySelector('og-optout-button') : null;
  };

  /**
   * The single source of truth for whether the discounted price
   * should show: a direct, real-time read of whether 'subscribed' is
   * present on <og-offer> right now. No stored variable, no default
   * state, no syncing from any OG JS API.
   */
  const isSubscribed = () => {
    const offer = getOffer();
    return !!(offer && offer.hasAttribute('subscribed'));
  };

  const setPrice = showSubscription => {
    const wrapper = getWrapper();
    if (!wrapper) return;

    const sub = wrapper.querySelector('[data-subscription-price-wrapper]');
    const reg = wrapper.querySelector('[data-regular-price-wrapper]');

    if (!sub || !reg) return;

    sub.style.setProperty('display', showSubscription ? 'block' : 'none', 'important');
    reg.style.setProperty('display', showSubscription ? 'none' : 'block', 'important');
  };

  /**
   * Applies whatever the current real DOM state says, without
   * clicking or selecting anything. Safe to call as often as needed.
   */
  const applyCurrentState = () => {
    setPrice(isSubscribed());
  };

  /**
   * Actively selects one-time purchase once, with a real click on
   * the opt-out control, the same kind of genuine interaction a user
   * would make. Polls briefly in case the offer/buttons aren't in
   * the DOM yet at the moment this first runs. Never fires more than
   * once per modal instance.
   */
  const selectOneTimeOnce = () => {
    if (state.hasSelectedOneTime) return;

    const optout = getOptoutButton();

    if (optout) {
      state.hasSelectedOneTime = true;
      optout.click();
      return;
    }

    if (state.selectOneTimeAttempts++ < 20) {
      setTimeout(selectOneTimeOnce, 250);
    }
  };

  /**
   * Watches for the 'subscribed' attribute changing anywhere in the
   * document and re-applies price state whenever it does. This is
   * the only trigger tied to subscription selection — no OG JS
   * callback API, no guessed intent from click text.
   */
  const bindSubscribedAttributeObserver = () => {
    if (state.attributeObserverBound) return;
    state.attributeObserverBound = true;

    const observer = new MutationObserver(mutations => {
      const relevant = mutations.some(
        m => m.type === 'attributes' && m.attributeName === 'subscribed'
      );

      if (!relevant) return;

      applyCurrentState();
    });

    observer.observe(document.body, {
      subtree: true,
      attributes: true,
      attributeFilter: ['subscribed']
    });
  };

  bindSubscribedAttributeObserver();
  selectOneTimeOnce();
  applyCurrentState();

  // A few delayed re-applies in case the offer/buttons render slightly
  // late after the modal opens.
  setTimeout(applyCurrentState, 300);
  setTimeout(applyCurrentState, 800);
  setTimeout(applyCurrentState, 1500);
}

		initModalProduct(){

			this.quickViewModal.querySelectorAll('[data-js-close]').forEach(elm=>{
				elm.addEventListener('click', ()=>{
					this.quickViewModal.hide();
				});
			});

			if ( this.quickViewModal.querySelector('[data-js-product-form]') ) {
				this.quickViewModal.querySelector('[data-js-product-form]').addEventListener('add-to-cart', ()=>{
					document.getElementById('site-cart-sidebar')?.scrollTo({top: 0, behavior: 'smooth'});
					this.quickViewModal.hide();
				});
			}

			if ( Shopify && Shopify.PaymentButton ) {
				setTimeout(()=>{
					Shopify.PaymentButton.init();
				}, 50);
			}
			setTimeout(() => {
  this.syncOGQuickViewPrice();
}, 100);

setTimeout(() => {
  this.syncOGQuickViewPrice();
}, 500);

setTimeout(() => {
  this.syncOGQuickViewPrice();
}, 1200);

			const productVariants = this.quickViewModal.querySelector('product-variants');
			if ( ! productVariants._defaultToFirstVariant ) {
				if ( parseInt(productVariants.dataset.variants) == 1 ) {
					productVariants.updateBuyButtons();
					this.quickViewModal.querySelector('product-page').onVariantChangeHandler({target:productVariants});
				}
			}

		}

		init(){

			this.quickViewModal = null;
			this.querySelector('a').addEventListener('keydown', e=>{
				if ( e.keyCode == window.KEYCODES.RETURN ) {
					window.lastFocusedElm = this.querySelector('a');
				}
			})
			this.querySelector('a').addEventListener('click', e=>{

				e.preventDefault();

				if ( ! this.quickViewModal ) {

					const target = e.currentTarget;

					target.classList.add('working');

					fetch(`${target.getAttribute('href')}${ target.getAttribute('href').includes('?') ? '&' : '?' }view=quick-view`)
						.then(response => response.text())
						.then(text => {

							const quickViewHTML = new DOMParser().parseFromString(text, 'text/html').querySelector('#product-quick-view');

							// create modal w content

							const quickViewContainer = document.createElement('div');
							quickViewContainer.innerHTML = `<modal-box id="modal-${target.dataset.id}"	
								class="modal modal--product" 
								data-options='{
									"enabled": false,
									"showOnce": false,
									"blockTabNavigation": true
								}'
								tabindex="-1" role="dialog" aria-modal="true" 
							>
								<div class="container--medium">
									<div class="modal-content" data-js-product-page>
										<button class="modal-close" data-js-close style="position:absolute;margin:0;top:0;right:0">${window.KROWN.settings.symbols.close}</button>
									</div>
								</div>
								<span class="modal-background" data-js-close></span>
							</modal-box>`;

							this.quickViewModal = quickViewContainer.querySelector('modal-box');
							document.body.appendChild(this.quickViewModal);
							this.quickViewModal.querySelector('.modal-content').innerHTML = quickViewHTML.innerHTML;

							console.log('MODAL RAN')

							setTimeout(()=>{
								this.initModalProduct();
							}, 100);
							this.quickViewModal.querySelector('[data-js-product-page]').addEventListener('reload', ()=>{
								this.initModalProduct();
							});

							if ( ! window.productPageScripts ) {
								const scripts = this.quickViewModal.querySelectorAll('script');
								scripts.forEach(elm=>{
									const script = document.createElement('script');
									script.src = elm.src;
									document.body.append(script);
									window.productPageScripts = true;
								});
							}

							setTimeout(()=>{
								this.quickViewModal.show();
								target.classList.remove('working');
							}, 250);
							
						});

} else {
  this.quickViewModal.show();

  setTimeout(() => {
    this.syncOGQuickViewPrice();
  }, 50);

  setTimeout(() => {
    this.syncOGQuickViewPrice();
  }, 300);

  setTimeout(() => {
    this.syncOGQuickViewPrice();
  }, 800);
}

			})
		}
	}

  if ( typeof customElements.get('quick-view-product') == 'undefined' ) {
		customElements.define('quick-view-product', QuickViewProduct);
	}

}